import { cn } from '@/shared/utils/shadcn';
import { useTranslations } from 'next-intl';
import React from 'react';
import Image from 'next/image';

const EnglishClass = ({ className }: { className?: string; onClose: () => void }) => {
  const t = useTranslations();
  const [isFold, setIsFold] = React.useState(false); // 是否折叠保过班

  return (
    <div className="fixed bottom-[16%] right-[2.6vw] z-[51] max-md:bottom-[30%] max-md:right-[30px]">
      {isFold ? (
        <div
          style={{
            background: `url(/images/common/getMoreClass.png)`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
          className={cn(
            'flex aspect-[239/104] h-auto w-[12.428vw] max-w-[239px] flex-col items-center justify-start max-md:w-24',
            className,
          )}
          onClick={() => setIsFold(false)}
        >
          <div className="flex aspect-[197/80] w-[82.4%] cursor-pointer flex-row items-center justify-center text-center font-medium text-[#212136] max-md:text-[10px] max-md:leading-3 md:text-[clamp(12px,1.04vw,20px)]">
            {t.rich('Common.getMoreClass', {
              br: () => <br />,
            })}
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center justify-end">
          <Image
            src={'/images/common/close.png'}
            width={28}
            height={28}
            className="absolute -right-[7px] -top-[5px] aspect-square h-auto w-[1.456vw] max-w-7 cursor-pointer max-md:w-4"
            alt="icon"
            onClick={() => setIsFold(true)}
          />

          {/* 法语保过班 */}
          <div
            style={{
              background: `url(/images/common/frenchClass.png)`,
              backgroundSize: '100% 100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
            className={cn(
              'flex aspect-[300/230] h-auto w-[15.6vw] max-w-[300px] flex-col items-center justify-end max-md:w-28',
              className,
            )}
          >
            <div className="mb-[6%] flex w-full flex-row items-center justify-start max-md:mb-[8%]">
              <div className="ml-[10%] w-[48%] text-center font-medium text-white max-md:text-[10px] max-md:leading-3 md:text-[clamp(12px,1.248vw,24px)]">
                {t.rich('Common.frenchClass', {
                  br: () => <br />,
                })}
              </div>
            </div>
            <div
              onClick={() => {
                window.open(
                  'https://posts.starringglobal.com/%e3%80%90%e6%b3%95%e8%af%ad%e4%bf%9d%e8%bf%87%e7%8f%ad%e3%80%916%e4%b8%aa%e6%9c%88%e6%8b%bfnclc7%ef%bc%8c%e9%a6%96%e8%80%83%e9%80%9a%e8%bf%87%e7%8e%87%e8%b6%8580%ef%bc%81/',
                  '_blank',
                );
              }}
              className="ml-[5%] box-border flex h-[19.1%] w-[82.6%] cursor-pointer flex-row items-center justify-center rounded-3xl border-[1px] border-white bg-gradient-to-t from-[#353878] to-[#4454B6] text-white max-md:text-[10px] max-md:leading-4 md:text-[clamp(12px,0.936vw,18px)]"
            >
              {t('Common.learnMore')}
            </div>
          </div>
          {/* 英语保过班 */}
          <div
            style={{
              background: `url(/images/common/englishClass.png)`,
              backgroundSize: '100% 100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
            className={cn(
              'flex aspect-[300/230] h-auto w-[15.6vw] max-w-[300px] flex-col items-center justify-end max-md:w-28',
              className,
            )}
          >
            <div className="mb-[6%] flex w-full flex-row items-center justify-start max-md:mb-[8%]">
              <div className="ml-[10%] w-[48%] text-center font-medium text-white max-md:w-[56%] max-md:text-[10px] max-md:leading-3 md:text-[clamp(12px,1.248vw,24px)]">
                {t.rich('Common.englishClass', {
                  br: () => <br />,
                })}
              </div>
            </div>
            <div
              onClick={() => {
                window.open(
                  'https://posts.starringglobal.com/%e9%80%9f%e6%8a%a2-pte%e8%8b%b1%e8%af%ad%e4%bf%9d%e8%bf%87%e7%8f%ad-%e6%af%94%e9%9b%85%e6%80%9d%e6%9b%b4%e5%ae%b9%e6%98%93-%e7%9f%ad%e6%9c%9f%e5%86%b2%e5%88%baclb7-9/',
                  '_blank',
                );
              }}
              className="ml-[5%] box-border flex h-[19.1%] w-[82.6%] cursor-pointer flex-row items-center justify-center rounded-3xl border-[1px] border-white bg-gradient-to-t from-[#353878] to-[#4454B6] text-white max-md:text-[10px] max-md:leading-4 md:text-[clamp(12px,0.936vw,18px)]"
            >
              {t('Common.learnMore')}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnglishClass;
